import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const NonPrivateRoute = ({ component: Component, ...rest }) => {
  // Add your own authentication on the below line.
  const { user_details } = useSelector((state) => state.authReducer);
  return (
    <Route
      {...rest}
      render={(props) => {
        return user_details &&
          user_details !== null &&
          user_details?.user?.merchant ? (
          <Redirect to={{ pathname: "/dashboard" }} />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default NonPrivateRoute;
